export const LAST_NEWS_REQUEST = "LAST_NEWS_REQUEST"
export const LAST_NEWS_SUCCESS = "LAST_NEWS_SUCCESS"
export const LAST_NEWS_FAIL = "LAST_NEWS_FAIL"